/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { Col, Row, Card, Button, Image, Modal } from 'react-bootstrap';

import { HeroSection, EditProfileModal, Header } from '../components';
import { useSMmyProfilePage } from '../machines';
import { vappContainer, VApplication } from '../../../application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { UserProfilePageService } from '../services';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { FileComp } from '../components/FileComp';
import { Loader } from '@/components';
import {
  useSMActivateUser,
  useSMReInviteUser,
  useSMRemoveAccess,
  useSMRevokeAdmin,
  useSMSuspendUser,
} from '@/pages/Admin/machines';
import { getUserId } from '../services/provider';
import toast from 'react-hot-toast';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const getSrv = () => {
  return vappContainer.get<UserProfilePageService>(
    UserProfilePageService.displayName
  );
};
const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const ContainerComm = (props: any) => {
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [isProfileExist, setIsProfileExist] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const staticPageContentConfig = getSrv()?.agent.getStaticPageContentSync();
  const [data, setData] = useState({ ...staticPageContentConfig?.sampleData });
  const srv = getSrv();
  const history = useNavigate();
  const { suspendUserSend, suspendUserState } = useSMSuspendUser({});
  const theme = useTheme();
  const [key, setkey] = useState('');
  const { myProfilePageMachine, myProfilePageSend, myProfilePageState } =
    useSMmyProfilePage({});
  const { reInviteUserMachine, reInviteUserSend, reInviteUserState } =
    useSMReInviteUser({});
  const { activateUserMachine, activateUserSend, activateUserState } =
    useSMActivateUser({});
  const { revokeAdminSend, revokeAdminState } = useSMRevokeAdmin({});
  const { removeAccessSend, removeAccessState } = useSMRemoveAccess({});
  const { userId } = getUserId();

  const onButtonPress = async (key: string) => {
    console.log('kye->', key);
    if (key === 'suspend') {
      //@ts-ignore
      const result = await SwalWithBootstrapButtons.fire({
        icon: 'warning',
        title: 'Confirm Suspend',
        text: 'Are you sure do you want to suspend this user?',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        suspendUserSend('START', {
          payload: userId,
        });
      }
    } else if (key === 're-invite') {
      //@ts-ignore
      const result = await SwalWithBootstrapButtons.fire({
        icon: 'warning',
        title: 'Confirm Reinvite',
        text: 'Are you sure do you want to Reinvite this user?',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        reInviteUserSend('START', {
          payload: userId,
        });
      }
    } else if (key === 'activate') {
      //@ts-ignore
      const result = await SwalWithBootstrapButtons.fire({
        icon: 'warning',
        title: 'Confirm Suspend',
        text: 'Are you sure do you want to activate this user?',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        activateUserSend('START', {
          payload: userId,
        });
      }
    } else if (key === 'revoke') {
      //@ts-ignore
      const result = await SwalWithBootstrapButtons.fire({
        icon: 'warning',
        title: 'Confirm revoke admin access',
        text: 'Are you sure about revoking admin access for this user?',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        revokeAdminSend('START', {
          payload: {
            vuid: userId,
            roleId: myProfilePageState?.event?.data?.value?.role?.[0]?.uuid,
          },
        });
      }
    } else if (key === 'remove') {
      //@ts-ignore
      const result = await SwalWithBootstrapButtons.fire({
        icon: 'warning',
        title: 'Confirm remove access',
        text: 'Are you sure about removing access for this user?',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        removeAccessSend('START', {
          payload: {
            vuid: userId,
          },
        });
      }
    }
  };

  const onRefresh = () => {
    myProfilePageSend('TRIGGER_REFRESH', {});
  };

  const _renderPage = () => {
    if (showForm) {
      return (
        <>
          <TweetyWidget
            labelColor={'#000000'}
            fields={staticPageContentConfig?.formData?.fields}
            // key={new Date().toString()}
            layout={staticPageContentConfig?.formData?.layout}
            validatorConfig={staticPageContentConfig?.formData?.validatorConfig}
            onFormSubmit={(payload: any) => {
              console.log('find->', payload);
              setData(
                getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData
              );
              setShowNotificationModal(true);
            }}
            renderSubmitButton={() => (
              <Button
                type="submit"
                style={{ position: 'relative', top: '520px' }}
                onClick={() => setShowNotificationModal(true)}
              >
                Next
              </Button>
            )}
            initialData={{}}
            submitButtonLabel={'Next'}
          />
          <FileComp
            formFields={staticPageContentConfig?.formData?.fileFields}
          />
        </>
      );
    }
    if (!isProfileExist) {
      return (
        <>
          <Loader {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
        </>
      );
    }
    if (myProfilePageState?.matches('RENDER_PAGE')) {
      console.log('find->', data);
      return (
        <>
          <HeroSection
            {...data}
            {...(myProfilePageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
          />
        </>
      );
    }
    if (myProfilePageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingProfile || {})} />
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (myProfilePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  const _renderSuspendError = () => {
    if (suspendUserState?.matches('SUSPEND_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.suspendUser || {})}
          description={[
            suspendUserState?.event?.data?.value,
            staticPageContentConfig?.error?.suspendUser?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderActivateError = () => {
    if (activateUserState?.matches('ACTIVATE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.activateUser || {})}
          description={[
            activateUserState?.event?.data?.value,
            staticPageContentConfig?.error?.activateUser?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  const _renderReInviteError = () => {
    if (reInviteUserState?.matches('RE_INVITE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.reinviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  console.log(
    'suspend->',
    suspendUserState?.matches('SUSPEND_USER_SUCCESS'),
    activateUserState?.matches('ACTIVATE_USER_SUCCESS')
  );

  const goBack = () => {
    history(-1);
  };

  const _renderRevokeNotification = () => {
    if (revokeAdminState?.matches('REVOKE_ADMIN_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.revokeAdminSuccess ||
              {})}
            onAcknowledgement={goBack}
            onDeny={goBack}
          />
        </>
      );
    }
  };
  const _removeAccessNotification = () => {
    if (removeAccessState?.matches('REMOVE_ACCESS_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.removeAccessSuccess ||
              {})}
            onAcknowledgement={goBack}
            onDeny={goBack}
          />
        </>
      );
    }
  };
  const _renderSuspendNotification = () => {
    if (suspendUserState?.matches('SUSPEND_USER_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.suspendUserSuccess ||
              {})}
            onAcknowledgement={onRefresh}
            onDeny={onRefresh}
          />
        </>
      );
    }
  };

  const _renderActivateNotification = () => {
    if (activateUserState?.matches('ACTIVATE_USER_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.activateUserSuccess ||
              {})}
            onAcknowledgement={onRefresh}
            onDeny={onRefresh}
          />
        </>
      );
    }
  };
  const _renderInviteNotification = () => {
    if (reInviteUserState?.matches('RE_INVITE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.reInviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            backButton={showForm}
            onBackClick={() => setShowForm(false)}
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderLoading = () => {
    if (reInviteUserState?.matches('RE_INVITE')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.inviteUser || {})}
        />
      );
    }
    if (revokeAdminState?.matches('REVOKE_ADMIN')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.revokeAdmin || {})}
        />
      );
    }
    if (removeAccessState?.matches('REMOVE_ACCESS')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.removeAccess || {})}
        />
      );
    }
    if (
      suspendUserState?.matches('SUSPEND_USER') ||
      activateUserState?.matches('ACTIVATE_USER')
    ) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.suspendUser || {})}
        />
      );
    }
  };

  return (
    <>
      {_renderHeader()}
      {_renderLoading()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderActivateError()}
      {_renderReInviteError()}
      {_renderSuspendError()}
      {_renderActivateNotification()}
      {_renderInviteNotification()}
      {_renderSuspendNotification()}
      {_removeAccessNotification()}
      {_renderRevokeNotification()}
    </>
  );
};
